import React from 'react';

type InlinePlaceholderMessageProps = {
  text?: string;
  placeholder: string;
  replacement: React.ReactNode;
  className?: string;
};

const InlinePlaceholderMessage: React.FC<InlinePlaceholderMessageProps> = ({
  text,
  placeholder,
  replacement,
  className,
}) => {
  if (!text || !placeholder || !text.includes(placeholder)) {
    return null;
  }

  const [beforePlaceholder, afterPlaceholder] = text.split(placeholder);

  return (
    <div className={className}>
      {beforePlaceholder && <span>{beforePlaceholder}</span>}
      {replacement}
      {afterPlaceholder && <span>{afterPlaceholder}</span>}
    </div>
  );
};

export default InlinePlaceholderMessage;
